import TableResetFilters from './tableResetFilters';

export default TableResetFilters;
